import React from 'react';
import { SpaceXS } from '@targetprocess/global-constants';
import classNames from 'classnames';
import ReactDOM from 'react-dom';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

var PopoverPosition = {
  bottomLeft: function bottomLeft(hostRect, popoverRect, containerScroll) {
    return {
      left: 0,
      top: hostRect.height + parseInt(SpaceXS) - containerScroll.top
    };
  },
  bottom: function bottom(hostRect, popoverRect, containerScroll) {
    return {
      left: '50%',
      marginLeft: -popoverRect.width / 2,
      top: hostRect.height + parseInt(SpaceXS) - containerScroll.top
    };
  },
  bottomRight: function bottomRight(hostRect, popoverRect, containerScroll) {
    return {
      right: 0,
      top: hostRect.height + parseInt(SpaceXS) - containerScroll.top
    };
  },
  topLeft: function topLeft(hostRect, popoverRect, containerScroll) {
    return {
      left: 0,
      bottom: hostRect.height + parseInt(SpaceXS) + containerScroll.top
    };
  },
  top: function top(hostRect, popoverRect, containerScroll) {
    return {
      left: '50%',
      marginLeft: -popoverRect.width / 2,
      bottom: hostRect.height + parseInt(SpaceXS) + containerScroll.top
    };
  },
  topRight: function topRight(hostRect, popoverRect, containerScroll) {
    return {
      right: 0,
      bottom: hostRect.height + parseInt(SpaceXS) + containerScroll.top
    };
  },
  leftTop: function leftTop(hostRect, popoverRect, containerScroll) {
    return {
      right: hostRect.width + parseInt(SpaceXS) - containerScroll.left,
      top: 0
    };
  },
  left: function left(hostRect, popoverRect, containerScroll) {
    return {
      right: hostRect.width + parseInt(SpaceXS) - containerScroll.left,
      marginTop: -popoverRect.height / 2,
      top: '50%'
    };
  },
  leftBottom: function leftBottom(hostRect, popoverRect, containerScroll) {
    return {
      right: hostRect.width + parseInt(SpaceXS) - containerScroll.left,
      marginTop: -popoverRect.height / 2,
      bottom: 0
    };
  },
  rightTop: function rightTop(hostRect, popoverRect, containerScroll) {
    return {
      left: hostRect.width + parseInt(SpaceXS) + containerScroll.left,
      top: 0
    };
  },
  right: function right(hostRect, popoverRect, containerScroll) {
    return {
      left: hostRect.width + parseInt(SpaceXS) + containerScroll.left,
      marginTop: -popoverRect.height / 2,
      top: '50%'
    };
  },
  rightBottom: function rightBottom(hostRect, popoverRect, containerScroll) {
    return {
      left: hostRect.width + parseInt(SpaceXS) + containerScroll.left,
      marginTop: -popoverRect.height / 2,
      bottom: 0
    };
  }
};

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".popover-body-container__popover__7-34-8 {\r\n  -webkit-box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.12);\r\n          box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.12);\r\n  border-radius: 4px;\r\n  border: 1px solid rgba(64, 66, 73, 0.1);\r\n  background: #FFFFFF;\r\n  z-index: 10000;\r\n  -webkit-box-sizing: border-box;\r\n          box-sizing: border-box;\r\n}\r\n\r\n.popover-body__popover__7-34-8 {\r\n  -webkit-box-sizing: border-box;\r\n          box-sizing: border-box;\r\n  padding: 12px;\r\n  font-size: 13px;\r\n  color: #000000;\r\n}\r\n\r\n.popover-body--no-padding__popover__7-34-8 {\r\n    padding: 0;\r\n  }\r\n\r\n.popover-tip__popover__7-34-8 {\r\n  position: absolute;\r\n  pointer-events: none;\r\n  z-index: 10001;\r\n  overflow: hidden;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-align: center;\r\n      -ms-flex-align: center;\r\n          align-items: center;\r\n  -webkit-box-pack: center;\r\n      -ms-flex-pack: center;\r\n          justify-content: center;\r\n}\r\n\r\n.popover-tip__popover__7-34-8:before {\r\n    content: '';\r\n    position: absolute;\r\n    display: block;\r\n    -webkit-box-sizing: border-box;\r\n            box-sizing: border-box;\r\n    background-color: #FFFFFF;\r\n    border: 1px solid rgba(64, 66, 73, 0.1);\r\n    /*\r\n        geometry FTW\r\n        \r\n        2*$popoverTipSize\r\n         _______ _______\r\n        |      /|\\      |\r\n        |    /  |  \\    |  $popoverTipSize\r\n        |  /    |    \\  |\r\n        |/______|______\\|\r\n        since tip is rotated 45 degrees, its width and height is a\r\n        diagonal of a square with side=$popoverTipSize, thus diagonal\r\n        is sqrt(2) * $popoverTipSize. \r\n        sqrt(2) ~= 1.414, 1.4 used here to prevent too much rounding\r\n        */\r\n    width: 11.2px;\r\n    height: 11.2px;\r\n    -webkit-transform: rotate(45deg);\r\n            transform: rotate(45deg);\r\n  }\r\n\r\n.popover-tip--bottom__popover__7-34-8,\r\n  .popover-tip--top__popover__7-34-8 {\r\n    width: 100%;\r\n    border-top: 1px #FFFFFF;\r\n    border-bottom: 1px #FFFFFF;\r\n    height: 9px;\r\n  }\r\n\r\n.popover-tip--left__popover__7-34-8,\r\n  .popover-tip--right__popover__7-34-8 {\r\n    border-left: 1px #FFFFFF;\r\n    border-right: 1px #FFFFFF;\r\n    height: 100%;\r\n    width: 9px;\r\n  }\r\n\r\n/*\r\n    To determine tip position, we need to rotate it\r\n    along the \"tip\" point, after that, the \"tip\" point\r\n    can be placed with exactly 50% offset from the origin\r\n    so that it is centered.\r\n    */\r\n\r\n.popover-tip--bottom__popover__7-34-8:before {\r\n    -webkit-transform-origin: left top;\r\n            transform-origin: left top;\r\n    left: 50%;\r\n    top: 0;\r\n  }\r\n\r\n.popover-tip--top__popover__7-34-8:before {\r\n    -webkit-transform-origin: right bottom;\r\n            transform-origin: right bottom;\r\n    right: 50%;\r\n    bottom: 0;\r\n  }\r\n\r\n.popover-tip--left__popover__7-34-8:before {\r\n    -webkit-transform-origin: right top;\r\n            transform-origin: right top;\r\n    right: 0;\r\n    top: 50%;\r\n  }\r\n\r\n.popover-tip--right__popover__7-34-8:before {\r\n    -webkit-transform-origin: left bottom;\r\n            transform-origin: left bottom;\r\n    left: 0;\r\n    bottom: 50%;\r\n  }\r\n";
var styles = {"popover-body-container":"popover-body-container__popover__7-34-8","popover-body":"popover-body__popover__7-34-8","popover-body--no-padding":"popover-body--no-padding__popover__7-34-8","popover-tip":"popover-tip__popover__7-34-8","popover-tip--bottom":"popover-tip--bottom__popover__7-34-8","popover-tip--top":"popover-tip--top__popover__7-34-8","popover-tip--left":"popover-tip--left__popover__7-34-8","popover-tip--right":"popover-tip--right__popover__7-34-8"};
styleInject(css);

var PopoverBody = function PopoverBody(_ref) {
  var children = _ref.children,
      className = _ref.className,
      classNameBody = _ref.classNameBody,
      noPadding = _ref.noPadding;
  return React.createElement("div", {
    className: classNames(className, styles['popover-body-container'])
  }, React.createElement("div", {
    className: classNames(classNameBody, styles['popover-body'], noPadding && styles['popover-body--no-padding'])
  }, children));
};

var throttle = function throttle(func, limit) {
  var lastFunc = null;
  var lastRan = null;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (lastRan) {
      clearTimeout(lastFunc);
      lastFunc = setTimeout(function () {
        if (Date.now() - lastRan >= limit) {
          func.apply(void 0, args);
          lastRan = Date.now();
        }
      }, limit - (Date.now() - lastRan));
    } else {
      func.apply(void 0, args);
      lastRan = Date.now();
    }
  };
};

var PopoverContainer =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PopoverContainer, _React$Component);

  function PopoverContainer() {
    var _this;

    _classCallCheck(this, PopoverContainer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PopoverContainer).apply(this, arguments));
    _this.mounted = false;
    _this.popoverContentRef = React.createRef();
    _this.state = {
      adjusted: false,
      positionX: 0,
      positionY: 0
    };

    _this.onResize = function () {
      return _this.adjustPosition();
    };

    _this.onScroll = throttle(function () {
      _this.adjustPosition();
    }, _this.props.scrollThrottleIntervalMs || 200);

    _this.getPopoverTipPosition = function (popoverPosition, containerPosition) {
      if (popoverPosition.bottom && popoverPosition.bottom >= containerPosition.height) {
        return 'top';
      }

      if (popoverPosition.top && popoverPosition.top >= containerPosition.height) {
        return 'bottom';
      }

      if (popoverPosition.left && popoverPosition.left >= containerPosition.width) {
        return 'right';
      }

      if (popoverPosition.right && popoverPosition.right >= containerPosition.width) {
        return 'left';
      }

      return null;
    };

    return _this;
  }

  _createClass(PopoverContainer, [{
    key: "adjustPosition",
    value: function adjustPosition() {
      var _this2 = this;

      if (!this.mounted) {
        return;
      }

      var containerElement = this.props.containerElement || document.body;
      var positioningBoundingRect = this.props.positioningTarget.getBoundingClientRect();
      this.setState({
        // getBoundingClientRect() returns a DOMRect object that doesn't spread via
        // object spread (...) operator and has readonly properties, we convert it
        // to plain object for transparency
        hostRect: {
          top: this.props.relativeToParent ? 0 : positioningBoundingRect.top,
          left: this.props.relativeToParent ? 0 : positioningBoundingRect.left,
          right: this.props.relativeToParent ? 0 : positioningBoundingRect.right,
          bottom: this.props.relativeToParent ? 0 : positioningBoundingRect.bottom,
          width: positioningBoundingRect.width,
          height: positioningBoundingRect.height
        },
        popoverRect: this.popoverContentRef.current.getBoundingClientRect(),
        scroll: containerElement === document.body ? {
          left: 0,
          top: 0
        } : {
          left: containerElement.scrollLeft,
          top: containerElement.scrollTop
        }
      });
      window.requestAnimationFrame(function () {
        if (_this2.mounted) {
          _this2.setState({
            adjusted: true
          });
        }
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
      this.adjustPosition();
      document.addEventListener('scroll', this.onScroll);
      window.addEventListener('resize', this.onResize);

      if (this.props.containerElement && this.props.containerElement !== document.body) {
        this.props.containerElement.addEventListener('scroll', this.onScroll);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(previousProps) {
      if (this.props.containerElement !== previousProps.containerElement || this.props.getPopoverPosition !== previousProps.getPopoverPosition) {
        this.adjustPosition();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;

      if (this.onScroll) {
        document.body.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);

        if (this.props.containerElement && this.props.containerElement !== document.body) {
          this.props.containerElement.removeEventListener('scroll', this.onScroll);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var getPopoverPosition = typeof this.props.getPopoverPosition === 'function' ? this.props.getPopoverPosition : PopoverPosition[this.props.getPopoverPosition] || PopoverPosition.bottomLeft;
      var position = this.state.hostRect ? getPopoverPosition(this.state.hostRect, this.state.popoverRect, this.state.scroll) : {};
      var containerPosition = {
        left: this.state.hostRect ? this.state.hostRect.left - this.state.scroll.left : 0,
        top: this.state.hostRect ? this.state.hostRect.top - this.state.scroll.top : 0,
        width: this.state.hostRect && this.state.hostRect.width,
        height: this.state.hostRect && this.state.hostRect.height
      };
      var tipPosition = this.getPopoverTipPosition(position, containerPosition); // FIXME: position.top cast to number, because value may be not a number

      return React.createElement("div", {
        style: Object.assign({
          position: 'absolute'
        }, containerPosition, {
          pointerEvents: 'none',
          zIndex: this.props.zIndex,
          transition: '0.1s',
          transitionProperty: 'opacity',
          opacity: this.state.adjusted ? 1 : 0
        })
      }, this.props.showTip && tipPosition && React.createElement("div", {
        className: classNames(styles['popover-tip'], styles["popover-tip--".concat(tipPosition)], 'popover-tip'),
        style: {
          top: tipPosition === 'bottom' && position.top - 8,
          bottom: tipPosition === 'top' && position.bottom - 8,
          left: tipPosition === 'right' && position.left - 8,
          right: tipPosition === 'left' && position.right - 8
        }
      }), React.createElement("div", {
        ref: this.popoverContentRef,
        style: Object.assign({
          position: 'absolute',
          pointerEvents: 'all'
        }, position),
        className: this.props.className
      }, this.props.children));
    }
  }]);

  return PopoverContainer;
}(React.Component);

var PositioningTarget =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PositioningTarget, _React$Component);

  function PositioningTarget() {
    var _this;

    _classCallCheck(this, PositioningTarget);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PositioningTarget).apply(this, arguments));
    _this.state = {
      target: null
    };
    _this.targetRef = React.createRef();
    return _this;
  }

  _createClass(PositioningTarget, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        target: this.targetRef.current
      });
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement("div", {
        ref: this.targetRef
      }, this.props.children(this.state.target));
    }
  }]);

  return PositioningTarget;
}(React.Component);

var BodyDomNode =
/*#__PURE__*/
function (_React$Component) {
  _inherits(BodyDomNode, _React$Component);

  function BodyDomNode() {
    var _this;

    _classCallCheck(this, BodyDomNode);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BodyDomNode).apply(this, arguments));
    _this.state = {
      node: null
    };

    _this._onEvent = function (event) {
      if (!_this.state.node.contains(event.target) && !_this.props.positioningTarget.contains(event.target)) {
        _this.props.onOuterAction(event);
      }
    };

    _this._addDocumentEventListeners = function () {
      if (_this.props.outerActionEvents && _this.props.onOuterAction) {
        _this.props.outerActionEvents.forEach(function (event) {
          return document.addEventListener(event, _this._onEvent);
        });
      }
    };

    _this._removeDocumentEventListeners = function () {
      var outerActionEvents = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props.outerActionEvents;

      if (outerActionEvents) {
        outerActionEvents.forEach(function (event) {
          return document.removeEventListener(event, _this._onEvent);
        });
      }
    };

    return _this;
  }

  _createClass(BodyDomNode, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var node = document.createElement('div');
      document.body.appendChild(node);
      this.setState({
        node: node
      }, this._addDocumentEventListeners);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.outerActionEvents !== this.props.outerActionEvents || prevProps.onOuterAction !== this.props.onOuterAction) {
        this._removeDocumentEventListeners(prevProps.outerActionEvents);

        this._addDocumentEventListeners();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.node) {
        document.body.removeChild(this.state.node);

        this._removeDocumentEventListeners();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children(this.state.node);
    }
  }]);

  return BodyDomNode;
}(React.Component);

var StatelessPopover =
/*#__PURE__*/
function (_React$Component) {
  _inherits(StatelessPopover, _React$Component);

  function StatelessPopover() {
    var _this;

    _classCallCheck(this, StatelessPopover);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(StatelessPopover).apply(this, arguments));

    _this.getContainer = function () {
      return _this.props.getContainerElement && _this.props.getContainerElement() || document.body;
    };

    return _this;
  }

  _createClass(StatelessPopover, [{
    key: "renderPortalContent",
    value: function renderPortalContent(_ref) {
      var props = _ref.props,
          container = _ref.container,
          positioningTarget = _ref.positioningTarget;
      var popoverContent = React.createElement(PopoverContainer, {
        key: "popover-portal",
        getPopoverPosition: this.props.getPopoverPosition,
        relativeToParent: props.inline,
        containerElement: this.getContainer(),
        className: props.className,
        positioningTarget: positioningTarget,
        showTip: props.showTip,
        zIndex: props.zIndex
      }, props.body);

      if (!props.inline) {
        return ReactDOM.createPortal(popoverContent, container);
      }

      return popoverContent;
    }
  }, {
    key: "renderPortal",
    value: function renderPortal(positioningTarget) {
      var _this2 = this;

      if (!this.props.isOpen) {
        return null;
      }

      return this.props.inline ? this.renderPortalContent({
        props: this.props,
        positioningTarget: positioningTarget
      }) : React.createElement(BodyDomNode, {
        onOuterAction: this.props.onOuterAction,
        outerActionEvents: this.props.outerActionEvents,
        positioningTarget: positioningTarget
      }, function (container) {
        return container ? _this2.renderPortalContent({
          props: _this2.props,
          container: container,
          positioningTarget: positioningTarget
        }) : null;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return React.createElement(PositioningTarget, null, function (positioningTarget) {
        return positioningTarget ? React.createElement(React.Fragment, null, _this3.props.children, _this3.renderPortal(positioningTarget)) : null;
      });
    }
  }]);

  return StatelessPopover;
}(React.Component);

var Popover =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Popover, _React$Component);

  function Popover() {
    var _this;

    _classCallCheck(this, Popover);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Popover).apply(this, arguments));
    _this.state = {
      isOpen: false
    };

    _this.setOpened = function (isOpen) {
      _this.setState({
        isOpen: isOpen
      });
    };

    _this.onOuterAction = function (event) {
      if (_this.props.closeOnOuterAction) {
        _this.setOpened(false);
      }

      if (_this.props.onOuterAction) {
        _this.props.onOuterAction(event);
      }
    };

    return _this;
  }

  _createClass(Popover, [{
    key: "render",
    value: function render() {
      var isOpen = typeof this.props.isOpen === 'undefined' ? this.state.isOpen : this.props.isOpen;
      var children = typeof this.props.children === 'function' ? this.props.children({
        isOpen: isOpen,
        setOpened: this.setOpened
      }) : this.props.children;
      return React.createElement(StatelessPopover, Object.assign({}, this.props, {
        onOuterAction: this.onOuterAction,
        isOpen: isOpen
      }), children);
    }
  }]);

  return Popover;
}(React.Component);
Popover.Body = PopoverBody;
Popover.Position = PopoverPosition;
Popover.defaultProps = {
  zIndex: 19999,
  outerActionEvents: ['mousedown', 'touchstart'],
  getPopoverPosition: 'bottomLeft'
};

export default Popover;
export { Popover, PopoverBody, PopoverPosition };
